var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { PdfToolsViewer } from '@pdftools/pdf-web-viewer';
import './styles.scss';
function init() {
    return __awaiter(this, void 0, void 0, function* () {
        const container = document.getElementById('viewer-container');
        const viewer = new PdfToolsViewer();
        yield viewer.initialize({
            accessibilityLayerEnabled: true,
            inputDocument: {
                uri: '../WebViewer_v5_demo.pdf',
            },
            licenseKey: '<VIEWWEB,V5,AGA5BXUV7VHC7080U1F>',
            theme: 'light',
        }, container);
    });
}
init();
